import { Meses } from '@constants/Text'
import { toPercent } from '@utils/Format'

const MONTH_LABELS = Meses.map((m) => m.toUpperCase())

export const formatMonthlyReturnTable = (walletAnalysis) => {
  if (!walletAnalysis) return {}
  const aggregated = walletAnalysis.monthly_return_table
  if (aggregated && typeof aggregated === 'object' && !Array.isArray(aggregated)) {
    return aggregated
  }
  const monthly = walletAnalysis.monthly_return
  if (!monthly) return {}
  const index = Array.isArray(monthly.index) ? monthly.index : []
  const values = Array.isArray(monthly.values) ? monthly.values : []
  if (index.length === 0 || values.length === 0) return {}
  const table = {}
  for (let i = 0; i < index.length; i++) {
    addEntry(table, index[i], values[i])
  }
  return table
}

const addEntry = (table, rawDate, rawValue) => {
  const parsed = parseYearMonth(rawDate)
  if (!parsed) return
  const label = MONTH_LABELS[parsed.monthIndex]
  if (!label) return
  if (!table[parsed.year]) table[parsed.year] = {}
  table[parsed.year][label] = { rent: formatPercent(rawValue) }
}

const parseYearMonth = (raw) => {
  if (typeof raw !== 'string') return null
  const match = /^(\d{4})-(\d{2})/.exec(raw)
  if (!match) return null
  const monthIndex = Number(match[2]) - 1
  if (monthIndex < 0 || monthIndex > 11) return null
  return { year: match[1], monthIndex }
}

const formatPercent = (value) => {
  if (value === null || value === undefined) return '-'
  if (typeof value !== 'number' || !Number.isFinite(value)) return '-'
  return toPercent(value * 100)
}
